import { render, staticRenderFns } from "./RolesManage.vue?vue&type=template&id=053716d5&scoped=true&"
import script from "./RolesManage.vue?vue&type=script&lang=js&"
export * from "./RolesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053716d5",
  null
  
)

export default component.exports